import { Strategy } from 'utility-ts-strategy';
import { ITimelineTheme } from '../../../interfaces/scheduler_interfaces';

export let TimelineThemeStrategy = new Strategy<ITimelineTheme>({
  'clr-1-bkg': {
    theme: 'red'
  },
  'clr-2-bkg': {
    theme: 'orange'
  },
  'clr-3-bkg': {
    theme: 'yellow'
  },
  'clr-4-bkg': {
    theme: 'green'
  },
  'clr-5-bkg': {
    theme: 'teal'
  },
  'clr-6-bkg': {
    theme: 'blue'
  },
  'clr-7-bkg': {
    theme: 'cyan'
  },
  'clr-8-bkg': {
    theme: 'purple'
  },
  'clr-9-bkg': {
    theme: 'magenta'
  },
  'clr-10-bkg': {
    theme: 'white'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/timeline/strategies/timeline_theme_strategy.ts